if (!customElements.get('deseo-pedido')) {
  customElements.define(
    'deseo-pedido',
    class DeseoPedido extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');

        this.form.addEventListener('input', () => this.refresh());
        this.form.addEventListener('change', () => this.refresh());
        this.form.addEventListener('submit', (event) => this.send(event));
        this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }

      // Un solo producto (boton "Pedir por WhatsApp" de la pagina de producto).
      open(data) {
        this.items = null;
        this.data = data;
        this.querySelector('[data-resumen]').textContent = this.productName(data);
        this.querySelector('[data-precio]').textContent = this.money(data.price);
        this.showMode();
        this.refresh();
        this.dialog.showModal();
      }

      // Todos los productos de "Mi pedido" (carrito). Se leen de /cart.js para tener cantidades al dia.
      async openCart() {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        if (!cart.items || cart.items.length === 0) return;

        this.data = null;
        this.items = cart.items.map((item) => ({
          title: item.product_title,
          variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
          quantity: item.quantity,
          line: item.final_line_price,
          url: window.location.origin + item.url,
          image: item.image,
        }));

        const list = this.querySelector('[data-lista]');
        list.replaceChildren(
          ...this.items.map((item) => {
            const li = document.createElement('li');
            li.className = 'deseo-pedido__item';
            if (item.image) {
              const img = document.createElement('img');
              img.src = item.image + (item.image.includes('?') ? '&' : '?') + 'width=120';
              img.alt = '';
              img.width = 48;
              img.height = 48;
              li.append(img);
            }
            const text = document.createElement('span');
            text.className = 'deseo-pedido__item-texto';
            text.textContent = `${item.quantity} × ${this.productName(item)}`;
            const price = document.createElement('strong');
            price.textContent = this.money(item.line);
            li.append(text, price);
            return li;
          })
        );

        this.showMode();
        this.refresh();
        this.dialog.showModal();
      }

      showMode() {
        const cartMode = Array.isArray(this.items);
        this.querySelector('[data-solo-uno]').hidden = cartMode;
        this.querySelector('[data-lista]').hidden = !cartMode;
      }

      refresh() {
        const domicilio = this.form.elements.entrega.value === 'domicilio';
        const box = this.querySelector('[data-domicilio]');
        box.hidden = !domicilio;
        box.querySelectorAll('[data-requerido]').forEach((input) => {
          input.required = domicilio;
        });
        this.querySelector('[data-total]').textContent = this.money(this.total());
      }

      total() {
        if (Array.isArray(this.items)) return this.items.reduce((sum, item) => sum + item.line, 0);
        return (this.data?.price || 0) * this.quantity();
      }

      quantity() {
        const n = parseInt(this.form.elements.cantidad.value, 10);
        return Number.isFinite(n) && n > 0 ? Math.min(n, 20) : 1;
      }

      productName(item) {
        return item.variant ? `${item.title} (${item.variant})` : item.title;
      }

      // Los precios de Shopify vienen en centavos.
      money(cents) {
        return '$' + Math.round((cents || 0) / 100).toLocaleString('es-CO');
      }

      send(event) {
        event.preventDefault();
        if (!this.form.reportValidity()) return;

        const f = this.form.elements;
        const nombre = f.nombre.value.trim();

        // El enlace de cada producto hace que WhatsApp muestre la foto en la vista previa.
        const lines = ['Hola Deseo 👋 Quiero pedir:'];
        if (Array.isArray(this.items)) {
          this.items.forEach((item) => {
            lines.push(`• ${item.quantity} × ${this.productName(item)} – ${this.money(item.line)}`, item.url);
          });
        } else {
          const qty = this.quantity();
          lines.push(`• ${qty} × ${this.productName(this.data)} – ${this.money(this.data.price)}`, this.data.url);
        }
        lines.push('');

        if (f.entrega.value === 'domicilio') {
          lines.push(`🛵 Domicilio · ${nombre}`, `📍 ${f.direccion.value.trim()}, ${f.barrio.value.trim()}`);
          if (f.indicaciones.value.trim()) lines.push(`📝 ${f.indicaciones.value.trim()}`);
          lines.push(`📱 ${f.celular.value.trim()}`);
        } else {
          lines.push(`🏪 Recoger en el local (Granada) · ${nombre}`);
        }

        lines.push(`💳 Pago: ${f.pago.value}`, `Total productos: ${this.money(this.total())}`);

        const phone = (this.dataset.phone || '').replace(/[^0-9]/g, '');
        const waUrl = `https://wa.me/${phone}?text=${encodeURIComponent(lines.join('\n'))}`;
        // Conversion: el cliente envia el pedido por WhatsApp (ver layout/theme.liquid).
        if (typeof window.deseoTrackWhatsApp === 'function') window.deseoTrackWhatsApp('pedido', waUrl);
        window.open(waUrl, '_blank', 'noopener');
        this.dialog.close();
      }
    }
  );
}
